import infoService from '@/services/info.service';

export const defaultFeatures = {
    CERTIFIED_UBO_EXTRACT: new Date() >= new Date(2024, 5, 1),
    LEGACY_TEMPLATE_CONTRACT: true,
    GODUTCH_BANKING: false,
    NOTARY_CANCEL: false,
    SKIP_PAYMENT_FOR_ADVISORS: false,
    END_OF_YEAR_POLICY: true,
    END_OF_YEAR_TRANSFER_POLICY: false,
    NO_DEVIATING_AMOUNT_OF_SHARES: true,
    URGENCY_DEVIATION_INCORPORATION_ADDRESS: false,
    URGENCY_ENGLISH_SHAREHOLDERS: false,
    WWFT_2026_RULES: true,
    ALLOW_NON_DUTCH_SHAREHOLDERS: true,
} as const;

export type FeatureFlagList = typeof defaultFeatures;

const features = ref<FeatureFlagList>(defaultFeatures);

export function useFeatureFlags() {
    const isFlagEnabled = (feature: keyof FeatureFlagList): boolean => {
        return features.value[feature];
    };

    onBeforeMount(async () => {
        const backendFeatures = await infoService.getFeatures();
        features.value = { ...defaultFeatures, ...backendFeatures };
    });

    return { isFlagEnabled };
}
